export function addSizekickScript () {
    const sizekickScript = document.getElementById('sizekick-script')
    if (!sizekickScript) {
        const script = document.createElement('script')
        script.id = 'sizekick-script'
        script.src = 'https://widget.sizekick.io/all4golf.js'
        script.type = "module"
        document.head.appendChild(script)
    }
}

export function removeSizekickScriptAndData () {
    const sizekickScript = document.getElementById('sizekick-script')
    if (sizekickScript) {
        document.head.removeChild(sizekickScript)
        delete window.sizekickProductData
    }
}
